<template>
  <div class="setting">
    <v-container>
      <h2 class="mb-2">Settings</h2>
      <div class="test">
        <p>Customerのコピー</p>
      </div>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <v-row row="12">
        <v-col cols="12" sm="12">
          <h3 class="mb-2">コピー元Customer名</h3>
          <v-text-field
            v-model="json.CopyFromCustomer"
            :class="[`mb-4`]"
            placeholder="コピー元"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          <h3 class="mb-2">コピー先Customer名</h3>
          <v-text-field
            v-model="json.CopyToCustomer"
            :class="[`mb-4`]"
            placeholder="コピー先"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          ※コピー先のプロジェクトのpageが存在しない場合のみコピーできます。<br />
          ※一覧の検索欄、帳票の特定フォーム取り込みなどfomrIDに依存する部分はコピーされません。
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-4">
        <v-btn @click="modalOpen" color="primary">コピーの実行</v-btn>
      </v-row>
      <v-dialog v-if="check_dialog" v-model="check_dialog" max-width="250">
        <check-dialog
          v-on:clickSubmit="modalClose"
          :message="'コピーしますか?'"
        />
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import checkDialog from "../../components/CheckDialog/CheckDialog";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  name: "CustomerCopy",
  components: {
    checkDialog,
  },
  data: () => ({
    drawer: true,
    json: {
      CopyFromCustomer: "",
      CopyToCustomer: "",
    },
    check_dialog: false,
  }),
  async mounted() {
    console.log("Mounted");
  },
  methods: {
    modalOpen() {
      if (this.json.customer != "") {
        this.check_dialog = true;
      }
    },
    async modalClose(value) {
      this.check_dialog = false;
      if (value) {
        console.log("コピーの実行");
        const response = await api.CustomerCopy(this.json);
        console.log(response);
      }
    },
    back() {
      history.back();
    },
  },
};
</script>
